import { dateToString } from '@/shared/lib';
import _ from 'lodash';
import { useActivityLogs } from './useActivityLogs';
import {
  IActivityLogProps,
  IFormattedActivityLog,
  IFormattedActivityLogItem,
} from './activityLogs.types';
import './activityLogs.scss';

const ActivityLogs = ({
  studyLogs,
  startStudyDate,
  timezone,
  studyTimeOffset,
  facilityCountry,
  facilityTimezone,
}: IActivityLogProps) => {
  const { logs } = useActivityLogs({
    studyLogs,
    timezone,
    studyTimeOffset,
    startStudyDate,
    facilityCountry,
    facilityTimezone,
  });

  return (
    <div className="activity-logs-wrapper">
      {_.map(logs, (log: IFormattedActivityLog, i: number) => (
        <div className="activity-log-date" key={i}>
          <div className="date">{log.display}</div>
          <div className="activity-log-times">
            {_.map(log.data, (item: IFormattedActivityLogItem) => (
              <div className="time-stone">
                <div className="time">
                  {dateToString({
                    startStudyDate,
                    isoDate: item.time,
                    timezone,
                    studyTimeOffset,
                    facilityCountry,
                    facilityTimezone,
                    format: 'HH:mm:ss',
                  })}
                </div>
                <div className="status">
                  <div>{item.description}</div>
                  {!_.isEmpty(item.subDescriptions) && (
                    <ul aria-label={item.description}>
                      {_.map(item.subDescriptions, (subItem: string, index: number) => (
                        <li key={index}>{subItem}</li>
                      ))}
                    </ul>
                  )}
                  <div className="action-by">
                    by
                    <span> {item.actionBy}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityLogs;
